/* global System */

export default {
  ContactPerson: () =>
    System.import(/* webpackChunkName: "ContactPerson" */ './index'),
}
